import React from 'react'
import PropTypes from 'prop-types'

export * from '@salesforce/retail-react-app/app/contexts'

export const AppStateContext = React.createContext()
export const AppStateProvider = ({children, appState}) => {
    return <AppStateContext.Provider value={appState}>{children}</AppStateContext.Provider>
}

AppStateProvider.propTypes = {
    children: PropTypes.node.isRequired,
    appState: PropTypes.object.isRequired
}
